/**
 * Created by JIA on 2022/9/19.
 */
import localforage from "localforage";
import _ from "lodash";

class LocalStorageFileHelper {
    constructor() {
        this.store = localforage.createInstance({
            driver: [localforage.INDEXEDDB, localforage.WEBSQL, localforage.LOCALSTORAGE],
            name: "AIC-LocalStorageFileHelper",
        });
    }

    /**
     * we treat ~/fs/temp...  and /fs/temp as same path
     * @param path
     * @returns {string|*}
     */
    normalizePath(path) {
        return _.startsWith(path, "~") ? _.trimStart(path, "~") : path;
    }

    getFile(path) {
        return this.store.getItem(this.normalizePath(path));
    }

    setFile(path, file) {
        return this.store.setItem(this.normalizePath(path), file);
    }

    removeFile(path) {
        return this.store.removeItem(this.normalizePath(path));
    }

    clear() {
        return this.store.clear();
    }
}

export default new LocalStorageFileHelper();
